<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'rank', 'writer_name', 'date']"
    />

    <!--  구분 -->
    <div>
      <h5><i class="dot"></i> 조사 구분</h5>
      <div class="grid grid-cols-4 mt-4">
        <div>
          <vs-checkbox v-for="value in ['정기조사']"
                       class="mr-6"
                       :checked="form.regularly === value"
                       @change="form.regularly = form.regularly === value ? '' : value ">
            {{value}}
          </vs-checkbox>
        </div>
        <div>
          <vs-checkbox v-for="value in ['수시조사 - 근골격계 질환자 발생 시', '수시조사 - 새로운 작업 및 설비 도입 시', '수시조사 - 업무의 양과 작업공정 등 작업환경 변경 시']"
                       class="mr-6 mb-2"
                       :checked="form.regularly === value"
                       @change="form.regularly = form.regularly === value ? '' : value ">
            {{value}}
          </vs-checkbox>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      checkIds: [],
      form: {
        stdInfo: {},
        regularly: "",
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 16px 0;

    &:first-child {
      padding: 0;
    }
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 7px;
    &:first-child {
      background: #f9f9f9;
      padding: 0;
    }
  }
}

.check::v-deep {
  justify-content: center !important;
  span {
    margin: 0;
  }
}
</style>
